import { call, put, take, select } from 'redux-saga/effects';

import { GET_PAGE_BREAKS } from './actions';
import { SAVE_PAGE_BREAKS } from 'reducers/dataModels';
import { notifications, GET_PAGE_BREAKS_FAIL, GET_PAGE_BREAKS_SUCCESS } from 'PipeRouter';
import { getPageBreaks as vsGetPageBreaks } from 'services/learnkit';


function* getPageBreaks() {
  yield take(GET_PAGE_BREAKS);

  try {
    console.time('getPageBreaks#getPageBreaks')
    const { pageBreaks } = yield call(vsGetPageBreaks);

    const { vbid } = yield select(state => state.reader.ebook);

    if (pageBreaks.length === 0 || vbid === '9781464193729') {
      throw new Error("no vital source page break information found");
    } else {
      yield put({ type: SAVE_PAGE_BREAKS, data: pageBreaks });
      yield put(notifications(GET_PAGE_BREAKS_SUCCESS));
    }
    console.timeEnd('getPageBreaks#getPageBreaks')
  } catch (err) {
    window.logger.error('GET_PAGE_BREAKS_FAIL', { err });
    yield put(notifications(GET_PAGE_BREAKS_FAIL));
  }
}


export default getPageBreaks;
